import { render, staticRenderFns } from "./IconEtsy.vue?vue&type=template&id=71630e72&"
import script from "./IconEtsy.vue?vue&type=script&lang=js&"
export * from "./IconEtsy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports